// src/constants/index.js
export const EMPTY_ARRAY = [];
export const EMPTY_OBJECT = {};
export const EMPTY_STRING = '';
export const EMPTY_FUNCTION = () => {};
export const TILE_SIZE = 42;

// =============================================================================
// 🎬 CINEMATIC SYSTEM CONSTANTS
// =============================================================================

/**
 * Core timing constant with environment variable check
 */
const TICK_DURATION_BASE_MS = 250; // Base tick duration at 1x speed

// Check for environment variable with proper warning
let TICK_DURATION_MS = TICK_DURATION_BASE_MS;
if (import.meta.env.VITE_TICK_DURATION_MS) {
  const envValue = parseInt(import.meta.env.VITE_TICK_DURATION_MS);
  if (!isNaN(envValue) && envValue > 0) {
    TICK_DURATION_MS = envValue;
  } else {
    console.warn('⚠️ [CONSTANTS] Invalid VITE_TICK_DURATION_MS value. Using default:', TICK_DURATION_BASE_MS);
  }
} else {
  console.warn('⚠️ [CONSTANTS] VITE_TICK_DURATION_MS not found in environment. Using default:', TICK_DURATION_BASE_MS);
}

export { TICK_DURATION_MS };

/**
 * Default durations for artificial actions (in ticks)
 */
export const DEFAULT_DURATIONS = {
  START_TITLE: 10,     // Show "Resolution Phase" for 10 ticks
  END_PAUSE: 5,        // Brief pause at end
  MINIMUM_ACTION: 1    // Minimum duration for any action
};

/**
 * CSS variable names for dynamic animation control
 */
export const CSS_VARIABLES = {
  ANIMATION_SPEED: '--cinematic-animation-speed',
  CURRENT_TICK: '--cinematic-current-tick'
};

// Constantes del juego
export const GAME_CONSTANTS = {
  MAX_ENERGY: 100,
  MAX_ACTION_POINTS: 3,
  TURN_TIME_LIMIT: 300,
  LOBBY_COUNTDOWN: 1,
};

export const DEFAULT_STATES = {
  game: {
    status: 'lobby',
    turn: 0,
    players: EMPTY_ARRAY,
    units: EMPTY_ARRAY,
  },
  player: {
    id: null,
    name: EMPTY_STRING,
    energy: 0,
  },
};

// Development and debugging configuration
// These values are read from environment variables (.env file)
export const CONFIG = {
  API_URL: import.meta.env.VITE_API_URL,
  DEBUG_MODE: import.meta.env.VITE_DEBUG_MODE === 'true',
  SHOW_COORD: import.meta.env.VITE_SHOW_COORD === 'true',
  SHOW_SNAPSHOT_INDEX: import.meta.env.VITE_SHOW_SNAPSHOT_INDEX === 'true',
  DEFAULT_CURRENT_STEP: isNaN(parseInt(import.meta.env.VITE_DEFAULT_CURRENT_STEP)) 
    ? import.meta.env.VITE_DEFAULT_CURRENT_STEP || "base"
    : parseInt(import.meta.env.VITE_DEFAULT_CURRENT_STEP),
  TICK_DURATION_MS: parseInt(import.meta.env.VITE_TICK_DURATION_MS) || 250,
  AUTO_PLAY_DELAY_TICKS: parseInt(import.meta.env.VITE_AUTO_PLAY_DELAY_TICKS) || 1,
};
